import styles from "./index.module.css";

type Props = {
  text: string;
};

export const TitleComponent = ({ text }: Props) => {
  return <div className={styles.text}>{text}</div>;
};
